<template>
  <nav class="pagination-nav">
    <ul :class="classNames">
      <li>
        <a
          href="#"
          @click.prevent="firstPage()"
        >&laquo;</a>
      </li>

      <li>
        <a
          href="#"
          @click.prevent="backPage()"
        >&laquo;</a>
      </li>
      <li>
        <a
          href="#"
          @click.prevent="nextPage()"
        >&raquo;</a>
      </li>
      <li>
        <a
          href="#"
          @click.prevent="lastPage()"
        >&raquo;</a>
      </li>
    </ul>
  </nav>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      results: {
        type: Number,
        required: false,
        default: 20,
      },
      classNames: {
        type: String,
        required: false,
      },
      condition: {
        type: [Array, Object],
        required: false,
      },
      dispatchToCall: {
        type: String,
        required: true,
      },

      lastPageProp: {
        type: Number,
        required: true,
      },
      idCategory: {
        type: [Number, String],
        required: false,
        validator(value) {
          return parseInt(value, 10);
        },
      },
    },
    data() {
      return {
        totalPages: '',
        session: {
          page: 1,
          results: 20,
          apiKey: sessionStorage.getItem('apiKey'),
          userId: sessionStorage.getItem('userId'),
        },
      };
    },
    mounted() {
      this.startPageinate(this.idCategory);
    },
    methods: {
      firstPage() {
        this.emitEvent();
        this.callDispach(1, this.idCategory);
      },
      nextPage() {
        this.emitEvent();
        const pageToShow = parseInt(this.$route.query.page, 10) + 1;

        if (this.$route.query.page && (pageToShow <= Math.ceil(this.lastPageProp / this.results))) {
          this.callDispach(pageToShow, this.idCategory);
        }
      },
      backPage() {
        this.emitEvent();

        const pageToShow = parseInt(this.$route.query.page, 10) - 1;

        if (this.$route.query.page && pageToShow >= 1) {
          this.callDispach(pageToShow, this.idCategory);
        }
      },
      lastPage() {
        this.emitEvent();

        const lastPage = Math.ceil(this.lastPageProp / this.results);

        this.callDispach(lastPage, this.idCategory);
      },
      callDispach(pageToShow = 1, idCategory = null) {
        this.$router.push({
          query: Object.assign({}, this.$route.query, {
            page: pageToShow
          })
        });

        this.session.page = pageToShow;
        this.session.idCategory = parseInt(idCategory, 10);

        this.$store.dispatch(`${this.dispatchToCall}`, this.session);
      },
      emitEvent() {
        this.$emit('changePage', false);
      },

      startPageinate(idCategory = null) {
        this.session.idCategory = parseInt(idCategory, 10);
        if (!this.$route.query.page || this.$route.query.page <= 1) {
          this.$router.push({
            query: Object.assign({}, this.$route.query, {
              page: 1
            })
          });

          this.$store.dispatch(`${this.dispatchToCall}`, this.session);
        } else {
          this.session.page = this.$route.query.page;
          this.$store.dispatch(`${this.dispatchToCall}`, this.session);
        }
      },
      pageChange() {
        this.pagination.recipients = this.computedRecipients;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// _source/javascript/components/pagination/pagination.vue